/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "star-knockout-39f50ebe--sprite",
  "use": "star-knockout-39f50ebe--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"star-knockout-39f50ebe--sprite\"><rect width=\"36\" height=\"36\" fill=\"none\" /><g transform=\"translate(16.574 -803.01)\"><path d=\"M1.426,812.009a9,9,0,1,0,9,9A9,9,0,0,0,1.426,812.009Zm5.83,7.75-2.3,2.18a.522.522,0,0,0-.16.47l.55,3.07a.567.567,0,0,1-.47.63.647.647,0,0,1-.34-.06l-2.85-1.45a.572.572,0,0,0-.51,0l-2.85,1.45a.561.561,0,0,1-.75-.24.539.539,0,0,1-.05-.33l.54-3.07a.522.522,0,0,0-.16-.47l-2.3-2.18a.534.534,0,0,1-.02-.75.518.518,0,0,1,.33-.16l3.18-.45a.537.537,0,0,0,.42-.29l1.42-2.8a.571.571,0,0,1,.77-.22.661.661,0,0,1,.22.22l1.42,2.8a.553.553,0,0,0,.42.29l3.19.45a.528.528,0,0,1,.47.58A.555.555,0,0,1,7.256,819.759Z\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
